import {Spot} from '@domain/shifthandover'
import {useUpmPlant} from '@hconnect/upm'

import {useAnomalyEventMedia} from './api/useAnomalyEventMedia'

export function useSpotAnomalyMedia(spotEvent: Spot | null, plantId: string) {
  const upmPlant = useUpmPlant({plantId})

  const spotOrbitLinks = (spotEvent?.eventLinks ?? []).filter((l) => l.eventLinkType === 'orbitPortal')
  const spotAnomalyIds = spotOrbitLinks.flatMap((l) => {
    try {
      const u = new URL(l.linkTargetUrl)
      const id = u.searchParams.get('anomalyId')
      return id ? [id] : []
    } catch {
      return []
    }
  })

  const anomalyEventMedia = useAnomalyEventMedia(upmPlant?.upmId ?? plantId, spotAnomalyIds)

  return {
    ...anomalyEventMedia,
    orbitLink: spotOrbitLinks[0]
  }
}
